import {Component,Inject} from '@angular/core';
import {ROUTER_DIRECTIVES, NavigationEnd} from '@angular/router';

import {LoginService} from './login/login.service';
import {LoginComponent} from './login/login.component';
import {EmpresaService} from './empresa/empresa.service';
import {ProvinciaService} from './provincia/provincia.service';
import {PermisoService} from './permiso/permiso.service';
import {MenuService} from './menu/menu.service';
import {SucursalService} from './sucursal/sucursal.service';
import {UsuariosService} from './usuarios/usuario.service';
import {TipoVariableService} from './tipoVariable/tipoVariable.service';
import {RolService} from './rol/rol.service';
import {NodoService} from './nodo/nodo.service';
import {MedicionService} from './medicion/medicion.service';
import {RegAlarmaService} from './regAlarma/regAlarma.service';
import {UbicacionService} from './ubicacion/ubicacion.service';
import {GatewayService} from './gateway/gateway.service';
import {SensorService} from './sensor/sensor.service';
import {TipoSensorService} from './tipoSensor/tipoSensor.service';
import {TipoBateriaService} from './tipoBateria/tipoBateria.service';
import {AlarmaService} from './abmalarmas/alarma.service';
import {AvisoService} from './aviso/aviso.service';
import {NavLeftComponent} from './navLeft/navLeft.component';
import {NavSupComponent} from './navSup/navSup.component';
import {NavRightComponent} from './navRight/navRight.component';
import {ErrorComponent} from './error/error.component';
import {LandingPageComponent} from "./landingPage/landingPage.component";
import {AuthGuard} from './auth/auth-guard.service';
import {MiCuentaService} from "./miCuenta/miCuenta.service";
import {EmailService} from "./landingPage/email.service";
import {NotificacionService} from "./notificacion/notificacion.service";
import {RecargaCreditoService} from "./recargaCredito/recargaCredito.service";
import {InformeService} from "./informes/informe.service";
import {LogActividadService} from "./logActividad/logActividad.service";
import {HusoHorarioService} from "./husoHorario/husoHorario.service";
import {DocumentoService} from "./documento/documento.service";
import {Router} from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { PlanService } from './plan/plan.service';

@Component({
    selector: 'my-app',
    template: ` 
                <div id="contenedor" class="container-fluid" >
      		      <NavLeft *ngIf="url!='/'"></NavLeft>
      			  <NavSup [urlLogo]="urlLogo" *ngIf="url!='/'" [alertaCalibracion]="alertaCalibracion" [cantNotificaciones]="cantNotificaciones"></NavSup>
                  <NavRight [urlLogo]="urlLogo" *ngIf="url!='/'" (alerta)="alertaCalibracion = $event.alerta" (alertaNotificaciones)="cantNotificaciones = $event.alertaNotificaciones"></NavRight>
                  <Error *ngIf="url!='/'"></Error>
                  <div [ngClass]="{'login-inicio':(!loginService.isLoggedIn() || loginService.getDecodeToken().cambiarPassword) && url!='/','principal':(loginService.isLoggedIn() && !loginService.getDecodeToken().cambiarPassword) && url!='/'}">
                          <router-outlet></router-outlet>                    
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 marcoPie" *ngIf="url!='/'" [ngClass]="{'login-inicio':!loginService.isLoggedIn(),'footer':loginService.isLoggedIn()}" style="">
                      <div class="col-lg-11 col-md-11 col-sm-11 col-xs-9">
                          <p style="float:right; padding:15px 10px">
                          TBM S.R.L. | Rosario, Santa Fe (Argentina) | www.tbmsrl.com.ar | info@tbmsrl.com.ar | Lamadrid 470 - Zona i - Nave 2 - PB Of. 2 (S2001EBJ) | Tel: +54 341 5277920
                          </p>
                      </div>
                      <div class="col-lg-1 col-md-1 col-sm-1 col-xs-3">
                        <img class="tbmLogo" src="./img/logo_tbm.png" style="width: 100%; float:right"/>
                      </div>
                  </div>
      			</div>`,
    styles: [``],
    directives: [ROUTER_DIRECTIVES, NavLeftComponent, NavSupComponent, ErrorComponent, NavRightComponent],
    providers: [
        EmpresaService, ProvinciaService, AuthGuard, PermisoService, MenuService, SucursalService, NodoService, MedicionService, UsuariosService,
        RegAlarmaService, RolService, UbicacionService, GatewayService, SensorService, TipoSensorService, AlarmaService, AvisoService, TipoVariableService, MiCuentaService,
        EmailService, NotificacionService, RecargaCreditoService, TipoBateriaService, InformeService, LogActividadService, HusoHorarioService, DocumentoService, PlanService
    ],
    precompile: [LoginComponent,LandingPageComponent]
})
export class AppComponent {
    usuario: any;
    urlLogo: any;
    url:any;
    url2:any;
    alertaCalibracion:any;
    cantNotificaciones:any;

    constructor(private loginService: LoginService,
                private empresaService: EmpresaService, private router: Router,@Inject(DOCUMENT) private document: any) {
        this.urlLogo = "./img/logo_tbm.png";

        var indexBarra = this.document.location.href.lastIndexOf("/");
        this.url = this.document.location.href.substring(indexBarra);
        if (this.loginService.isLoggedIn()) {
            this.usuario = this.loginService.getDecodeToken();
            if (this.usuario != undefined && this.usuario.empresa != null && this.usuario.rol != "Tecnico" && this.usuario.rol != "Administrador")
                this.cargaFotoPerfil();
        }

        this.loginService.logIn.subscribe((mode) => {
            this.usuario = this.loginService.getDecodeToken();
            if (this.usuario != undefined && this.usuario.empresa != null && mode && this.usuario.rol != "Tecnico" && this.usuario.rol != "Administrador")
                this.cargaFotoPerfil();
        });

        window.addEventListener("storage", function () {
            if(!loginService.isLoggedIn())
                loginService.logout();
            else
                if(router.url === '/login')
                    location.reload();
        }, false);

        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.url = event.url;
                }
            });

    }

    private cargaFotoPerfil() {
        this.usuario = this.loginService.getDecodeToken();
        this.empresaService.getEmpresa(this.usuario.empresa).subscribe((empresa) => {
            //Cargo foto
            if (empresa != null && empresa.logo != undefined && empresa.logo.data != undefined) {
                var byteArray = new Uint8Array(empresa.logo.data.data);
                var file = new Blob([byteArray], {type: empresa.logo.contentType});
                var reader = new FileReader();
                reader.onloadend = function () {
                    this.urlLogo = reader.result;
                }.bind(this);
                if (file) {
                    reader.readAsDataURL(file);
                } else {
                    this.urlLogo = "";
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/app.component.ts